import 'css-chunksrc/client/pages/zonesPage/reportsPage/toolbar/styles.scss';export default {
  "toolbar": "_toolbar_qyjzv_1",
  "section": "_section_qyjzv_7",
  "title": "_title_qyjzv_13",
  "sort": "_sort_qyjzv_20",
  "filter": "_filter_qyjzv_24"
};